export default "/images/270cab0c6cb19ceb4bd1c5df1e6d4506.jpg";